import { isDevMode, enableProdMode } from '@angular/core';
import { environment } from '../../environments/environment';
export class AppSettings {
    public static BASE_URL = environment.BASE_URL;
    public static ADYEN_KEY = environment.ADYEN_KEY;
    public static ADYEN_MULTI = environment.ADYEN_MULTI;
    public static BASE_DOMAIN:string = environment.BASE_DOMAIN;
    public static CSS_CE_IMAGES = environment.CSS_CE_IMAGES;
    public static ROUTE_IMAGES = environment.ROUTE_IMAGES;
    public static STOP_IMAGES = environment.STOP_IMAGES;
    public static LOCATION_IMAGES = environment.LOCATION_IMAGES;
    public static POI_IMAGES = environment.POI_IMAGES;
    public static OPTION_IMAGES = environment.OPTION_IMAGES;
    public static APP_VERSION = environment.APP_VERSION;
    public static PACKAGE_VERSION:string = environment.PACKAGE_VERSION;
    public static ADYEN:string = environment.ADYEN;

    public static UPDATE_CURRENCY = `${AppSettings.BASE_URL}/api/currency/updateCurrency`;

    public static currencies = {1:'EUR',2:'GBP',3:'USD'};
    public static durationType = {1: 'MINUTE',2: 'HOUR',3: 'DAY'};

    // Rich cards values
    public static SOCIAL_GOOGLEPLUS = "";
    public static SOCIAL_FB = "https://www.facebook.com/CityExpertTravel/";
    public static SOCIAL_TWITTER = "https://twitter.com/CityExpert_";
    public static SOCIAL_INSTAGRAM = "https://www.instagram.com/city_expert";
    public static SOCIAL_LINKEDIN = "https://www.linkedin.com/company/cityexpert-worldwide/";
    public static SOCIAL_WIKIPEDIA = "";
    public static DESCRIPTION = "City Expert gestiona visitors centres y puntos de información turística en algunos de los destinos turísticos más populares.";
    public static FOUNDED = "2012";
    public static FOUNDER = "Enrique Ybarra";
    public static HEADQUARTERS = "Calle Jaén 2, primera planta. 41001. Sevilla";
    public static PRODUCTS = ["guided tours", "excursions", "attraction tickets", "activities"];
    public static CUSTOMER_SERVICE = "info@cityexpert.travel";
    public static GROUP_BOOKING = "reservas@cityexpert.travel";
    public static PHONE = "(+34) 900 920 092";
    public static LOGO = "https://city-sightseeing.com/assets/logo-city-expert.png";

    public static DEVICE_DESKTOP = 1;
    public static DEVICE_TABLET = 2;
    public static DEVICE_MOBILE = 3;
    
    public static TOP_PADDING = 64;

    // public static FREEGEOIP_URL = 'https://freegeoip.net/json/';
    public static GEOIP_TOOLS = 'https://geoip.tools/v1/json';
    
}
